export default {
	data() {
		return {
			phons_hyphen: "—",
		};
	},
    methods: {
        zeroPadding(num, length) {
            return ('0000000000' + num).slice(-length);
        },
        formatDate(date, hour, minute) {
            if (date === null || hour === null || minute === null) {
                return null
            }
            const [year, month, day] = date.replace(/-/g, "/").split("/");
            // 24時以上（翌日にまたがる時刻）はDateに日付を繰り上げさせる。
            // 日を文字列で加算すると月末で存在しない日付（例:7/32）になり、
            // ブラウザによってはInvalid Dateになるため。
            const tmpDate = new Date(
                parseInt(year, 10),
                parseInt(month, 10) - 1,
                parseInt(day, 10),
                Number(hour),
                Number(minute),
                0
            );
            const tmpYear = tmpDate.getFullYear();
            const tmpMonth = this.zeroPadding(tmpDate.getMonth() + 1, 2);
            const tmpDay = this.zeroPadding(tmpDate.getDate(), 2);
            const tmpHour = this.zeroPadding(tmpDate.getHours(), 2);
            const tmpMinute = this.zeroPadding(tmpDate.getMinutes(), 2);
            return `${tmpYear}/${tmpMonth}/${tmpDay} ${tmpHour}:${tmpMinute}:00`;
        },
        dateJp(date) {
            date.setTime(date.getTime() + 1000 * 60 * 60 * 9)
            return date.toISOString().substr(0, 10)
        },
        minuteToStrHours(num) {
            let hour = Math.floor(num / 60);
            let minute = num % 60;
            let dispHour = String(hour);
            if (dispHour.length < 3) {
                dispHour = this.zeroPadding(hour, 2)
            }

            return dispHour + ":" + this.zeroPadding(minute, 2);
        }
    },
}